export default __webpack_public_path__ + "static/media/1656.28e8b731.png";